<template>
  <div class="row border-bottom">
    <div class="col py-2">
      <div class="row mx-0">
        <div class="col">
          <div class="row">
            <div class="col-auto">
              <img
                src="@/assets/avatar.jpg"
                style="width: 48px"
                class="rounded-circle"
              />
            </div>
            <div class="col px-0">
              <div class="d-flex flex-column p-1">
                <auto-textarea
                  :min-height="minHeight"
                  :max-height="maxHeight"
                  v-model="value"
                />
              </div>
              <hr class="my-1 border border-info" />
              <div class="d-flex flex-row justify-content-between">
                <button class="btn rounded-circle btn-sm" id="deneme">
                  <input
                    @change="onFileSelected"
                    type="file"
                    multiple
                    id="upload_file"
                    accept="image/*"
                  /><i class="fas fa-image"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-info btn-sm text-white"
                  :disabled="!value"
                >
                  Paylaş
                </button>
              </div>
              <img
                class="img-thumbnail"
                v-bind:src="imagePreview"
                width="200"
                height="200"
                v-show="showPreview"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AutoTextarea from "./AutoTextarea.vue";
export default {
  components: { AutoTextarea },
  data() {
    return {
      selectedFile: null,
      imagePreview: null,
      showPreview: false,
      minHeight: 20,
      maxHeight: 150,
      value: "",
    };
  },
  methods: {
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];

      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      reader.readAsDataURL(this.selectedFile);
    },
    closeModal() {
      this.selectedFile = null;
      this.imagePreview = null;
      this.showPreview = false;
    },
  },
};
</script>

<style>
#deneme:hover {
  background: #cff5fc;
}
#deneme {
  color: #0dcaf0;
  text-align: center;
  position: relative;
  display: inline-block;
  overflow: hidden;
  z-index: 3;
  white-space: nowrap;
  font-size: 20px;
}
#deneme input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
</style>
